if(!customElements.get('comment-popup')){
    class CommentPopup extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.querySelectorAll('[data-type="close"]').forEach(item => {
                item.addEventListener('click', () => {
                    this.close();
                })
            })

            this.addEventListener('keyup', e => {
                if(e.code?.toUpperCase() === 'ESCAPE') this.close();
            })
            this.addEventListener('click', e => {
                if(e.target === this) this.close();
            })

            this.formComment = this.querySelector('#comment_form');

            this.inputWrappers = this.querySelectorAll('.input-wrapper');
            this.inputs = this.querySelectorAll('input, textarea');
            this.inputs.forEach(item => {
              item.addEventListener('focus', this.focusOnInput.bind(this));
              item.addEventListener('focusout', this.focusOutOnInput.bind(this));
            });
      
            this.labels = this.querySelectorAll('.input-wrapper label');
            this.labels.forEach(item => {
              item.addEventListener('click', (e) => {
                if(e.currentTarget.closest('.input-wrapper').getAttribute('data-selected') != 'true'){
                  const inputs = e.currentTarget.closest('.input-wrapper').querySelectorAll('input, textarea');
                  inputs.forEach(item => {
                    item.focus();
                  })
                }
              })
            })
        }

         focusOnInput(e){
            this.inputWrappers.forEach(item => {
                var input = item.querySelector('textarea, input');
                if(input.value.trim() == '') item.setAttribute('data-selected', 'false');
            })

            var currentTarget = e.currentTarget;
            var currentTargetInputWrapper = currentTarget.closest('.input-wrapper');
            currentTargetInputWrapper.setAttribute('data-selected', 'true');
        }

        focusOutOnInput(){
            this.inputWrappers.forEach(item => {
                var input = item.querySelector('textarea, input');
                if(input.value.trim() == '') item.setAttribute('data-selected', 'false');
            })
        }

        open(){
            this.setAttribute('data-hidden', 'false');
            document.documentElement.style.overflow = 'hidden';

            // focus
            let index = 0;
            const focusElem = setInterval(() => {
                var firstElem = this.querySelectorAll('[tabindex]:not([tabindex="-1"]')[0];
                firstElem.focus();
                var focusedElement = document.activeElement;

                index++;
                if(focusedElement === firstElem || index > 5){
                    clearInterval(focusElem);
                }
            }, 100)
        }

        close(){
            this.setAttribute('data-hidden', 'true');
            document.documentElement.style.overflow = 'initial';
        }
    }

    customElements.define('comment-popup', CommentPopup);
}

if(!customElements.get('custom-article')){
    class CustomArticle extends HTMLElement{
        constructor(){
            super();

            this.init();
        }

        init(){
            this.btnWriteComment = this.querySelector('.article-comment__btn');
            this.commentPopup = this.querySelector('comment-popup');

            if(this.btnWriteComment){
                this.btnWriteComment.addEventListener('click', this.openCommentPopup.bind(this));
            }

            this.commentForm = this.querySelectorAll('.comment-form');
            this.commentForm.forEach(item => {
                if(item.closest('.article-comments-wrapper')){
                    while(item.firstChild){
                        item.parentNode.insertBefore(item.firstChild, item);
                    }

                    item.remove();
                }
            })

            this.checkCommentError();
        }

        checkCommentError(){
            if(this.querySelector('.comment__message')){
                this.openCommentPopup();
            }
        }

        openCommentPopup(){
            if(this.commentPopup){
                this.commentPopup.open();
            }
        }
    }

    customElements.define('custom-article', CustomArticle);
}

if(!customElements.get('pagination-text')){
    class PaginationText extends HTMLElement { // Pagination text for comment section
        constructor(){
            super();

            this.init();
        }

        init(){
            this.btnLoadMore = this.querySelector('.btn-load-more');

            this.commentList = this.closest('custom-article');
            this.commentsWrapper = this.commentList.querySelector('.article-comments');

            this.btnLoadMore.addEventListener('click', e => {
                this.btnLoadMore.setAttribute('data-disabled', 'true');
                this.loadMoreComments();
            })

            this.btnLoadMore.addEventListener('keydown', e => {
                if(e.key === 'Enter'){
                    this.btnLoadMore.setAttribute('data-disabled', 'true');
                    this.loadMoreComments();
                }
            })
        }

        async loadMoreComments(){
            try{
                const nextPageRes = await fetch(
                    `${this.btnLoadMore.dataset.url}`
                );
                const nextPageText = await nextPageRes.text();
                const nextPageHTML = new DOMParser().parseFromString(nextPageText, 'text/html');

                const commentsWrapper = nextPageHTML.querySelector('.article-comments');
                const btnLoadMore = nextPageHTML.querySelector('#comments .btn-load-more');

                // get comments
                const comments = commentsWrapper.querySelectorAll('.article-comment');
                comments.forEach(item => {
                    this.commentsWrapper.appendChild(item);
                });

                if(btnLoadMore){
                    this.btnLoadMore.classList.remove('d-none');
                    this.btnLoadMore.setAttribute('data-url', `${btnLoadMore.dataset.url}`)
                }else{
                    this.btnLoadMore.classList.add('d-none');
                }

            }catch(error){

                console.error(error);
                alert(error.message);

            } finally {
                this.btnLoadMore.setAttribute('data-disabled', 'false');
            }
        }
    }

    customElements.define('pagination-text', PaginationText);
}